import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  demo: {
    id: 'studio.JsZpzQ',
    defaultMessage: 'demo',
  },
});
